import React, { createContext, useContext, useState } from 'react';
import { translations } from './i18n';

const LangContext = createContext();

function detectDefaultLang() {

  let browserLang =
    navigator.language ||
    navigator.languages?.[0] ||
    'en';
  if(browserLang=="en" || browserLang.startsWith('en')){
	  if(navigator.languages[2]) browserLang = navigator.languages[2]
  }
  const lang = browserLang.toLowerCase();

  if (lang.startsWith('id')) return 'id';
  if (lang.startsWith('vi')) return 'vi';
  if (lang.startsWith('th')) return 'th';
  if (lang.startsWith('tl')) return 'ph';
  if (lang.startsWith('fil')) return 'ph';

  return 'en';
}

export function LangProvider({ children }) {
 // const [lang, setLang] = useState('en');
  const [lang, setLang] = useState(
	localStorage.getItem('lang') || detectDefaultLang()
  );
  
  //console.log("lang", lang, detectDefaultLang())

  const t = translations[lang];
  const toggleLang = () => setLang(l => l === 'en' ? lang : 'en');

  return (
    <LangContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
